import { StateCreator } from "zustand";
import { SessionStorageKeys } from "../../constants";
import { IJWTSliceState } from "./jwtSliceCreator";

export interface IFingerprintSliceState {
  fingerprint: string;
  deviceJWT?: string;
  setFingerprint: (fnp: string) => void;
  setDeviceJwt: (jwt: string) => void;
  clearDeviceJwt: () => void;
}

export const fingerPrintSliceCreator: StateCreator<IFingerprintSliceState & IJWTSliceState, [], [], IFingerprintSliceState> = set => ({
  fingerprint: "",
  setFingerprint: (fnp) => {
    set({ fingerprint: fnp });
  },
  setDeviceJwt: (jwt) => {
    set(({ jwt: _jwt, ...rest }) => ({ ...rest, deviceJWT: jwt }), true);
  },
  clearDeviceJwt: () => {
    sessionStorage.removeItem(SessionStorageKeys.blockedLimitModalShown);
    set(({ deviceJWT, ...rest }) => rest, true);
  },
});
